
import { useParams } from "react-router-dom";
import { Box, useTheme } from "@mui/material";
import {
    Save as SaveIcon,
    Preview as PreviewIcon
} from '@mui/icons-material';

import { useMSALPayload } from "@initia-digital/auth-client-utils";
import { FilledButton } from "@initia-digital/component-library";
import { IPlan, IPlanStatus } from "@initia-digital/types/work-and-safety";

import { useWorkAndSafetyStore } from "../store";
import { useIsAdmin } from "../hooks";
import { ActionAPlanButton } from "./Buttons";
import { baseDefinedAndNotNullNarrowing } from "@initia-digital/ts-utils";


export interface IPlanActionsProps {
    handleSave: (plan?: IPlan) => void
    handleStatusChange?: (planId: string, status: IPlanStatus, notify: boolean) => void
}


export const PlanActions = ({
    handleSave,
    handleStatusChange,
}: IPlanActionsProps) => {
    // -------------------------------
    const { editPlanState } = useWorkAndSafetyStore();
    const { status } = editPlanState;

    const params = useParams();
    const { planId, jobId } = params;
    const isCreate = !baseDefinedAndNotNullNarrowing(planId);

    const theme = useTheme();

    const authDetail = useMSALPayload();
    const isAdmin = useIsAdmin(authDetail, true);

    return (
        <Box display="flex" flexDirection="row" flexWrap="wrap">
            <Box p="3px">
                <FilledButton
                    size="small"
                    onClick={() => handleSave(editPlanState)}
                    startIcon={<SaveIcon />}
                >
                    Save
                </FilledButton>
            </Box>
            {
                !isCreate &&
                <Box p="3px">
                    <Box>
                        <ActionAPlanButton
                            size="small"
                            planId={planId}
                            handleStatusChange={
                                baseDefinedAndNotNullNarrowing(handleStatusChange) ?
                                handleStatusChange :
                                () => console.error(`Handle status change for ${status} not provided`)}
                            status={status} isAdmin={isAdmin}
                        />
                    </Box>
                </Box>
            }
            {
                !isCreate &&
                <Box p="3px">
                    <Box>
                        <FilledButton
                            size="small"
                            startIcon={<PreviewIcon />}
                            color={theme.palette.secondary.contrastText} backgroundColor={theme.palette.secondary.main}
                            onClick={() => window.open(`${window.location.origin}/job/${jobId}/view-plan/${planId}`, '_blank')}
                        >
                            Preview
                        </FilledButton>
                    </Box>
                </Box>
            }
        </Box>
    )
}